import { DOCUMENT } from '@angular/common'
import { Component, Inject, Renderer2 } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'
import { MatDialogModule } from '@angular/material/dialog'
import { PdfViewerModule } from 'ng2-pdf-viewer'

@Component({
    selector: 'app-terms-of-service',
    standalone: true,
    imports: [PdfViewerModule, MatDialogModule, MatButtonModule],
    templateUrl: './terms-of-service.component.html',
    styleUrl: './terms-of-service.component.scss',
})
export class TermsOfServiceComponent {
    isTermsRead: boolean = false
    PDF_SCROLL_OFFSET = 1

    constructor(
        @Inject(DOCUMENT)
        private document: Document,
        private renderer: Renderer2
    ) {}

    onScroll(): void {
        const pdfContainer = this.document.querySelector<HTMLDivElement>(
            '.ng2-pdf-viewer-container'
        )

        if (!pdfContainer) {
            return
        }

        this.renderer.listen(pdfContainer, 'scroll', (event: Event) => {
            if (
                pdfContainer.scrollHeight - pdfContainer.scrollTop <=
                pdfContainer.clientHeight + this.PDF_SCROLL_OFFSET
            ) {
                this.isTermsRead = true
            }
        })
    }
}
